import { Box } from "@mui/material";
import React from "react";
import meem from "../../images/meem.png";
import Elements from "./elements";
import { links } from "./links";
import MailIcon from "@mui/icons-material/Mail";


const Home = () => {
  return (
    <Box sx={{ mt: { xs: 5, md: "10%" } }} className="text-white">
      <Box sx={{ display: { md: "flex" } }}>
        <Box className="md:w-1/2">
          <Box className="flex justify-center">
            <img
              className="w-1/2 border-circle border-primary-shadowed"
              src={meem}
              alt=""
            />
          </Box>
          <Box className="mt-5" align="center">
            <p className="text-white">
              <MailIcon sx={{ fontSize: "18px" }} /> meemrumi59@gmail.com
            </p>
            <Box className="mt-2">
              {links.map((link) => (
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={link?.link}
                  className="text-white mr-2"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title={link.title}
                >
                  <link.icon sx={{ height: "30px" }} />
                </a>
              ))}
            </Box>
          </Box>
        </Box>
        <Box className="flex justify-center mt-3">
          <Elements />
        </Box>
      </Box>
    </Box>
  );
};

export default Home;
